const getSourceAccount = (fundingAccount) => fundingAccount?.[0]?.[0] ?? {};

export const fundingAccountSelectors = {
  getSourceAccount,
};
